/**
 * 定制 接口的统一出口
 */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const customcomment = {
    // 列表
    list(params) {
        return axios.get(api + 'customcomment/list', { params: params })
    },
    // 详情
    detail(params) {
        return axios.get(api + 'customcomment/detail', { params: params })
    },
    // 状态
    status(params) {
        return axios.post(api + 'customcomment/status', qs.stringify(params))
    },
    // 删除
    remove(params) {
        return axios.post(api + 'customcomment/remove', qs.stringify(params))
    },

}

// 导出接口
export default customcomment

